// while this regex is *very* basic and doesn't comprehensively match guids it is sufficient
// for differentiating between a 'guid-like' id and any other similarly nested path
const guidRegex = '[0-9A-Fa-f\\-]{36}';

export const routeForDashboard = '/';

export const routeForMedicationLists = '/medications-list';

export const routeForNewMedicationList = '/medications-list/new';

export const routeForMedicationList = `/medications-list/:medListId(${guidRegex})`;

export const createRouteForMedicationList = (medListId: string) => `/medications-list/${medListId}`;

export const routeForDetailsMatch = (root: string) => `${root}/:medicationId`;

export const routeForPharmacyRequest = (root: string) => `${root}/new`;

export const routeForSummary = (root: string) => root;

export const routeForDetails = (root: string, medicationId: string) => `${root}/${medicationId}`;

export interface RouteParamsDetails {
    medicationId?: string;
}
